import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  q: '¿Necesito experiencia previa para unirme?',
  a: 'No. La formación está pensada para empezar desde cero, con un paso a paso claro para que puedas construir tu tienda online de productos físicos aunque hoy no sepas por dónde arrancar.'
}, {
  q: '¿Me sirve si ya tengo mi tienda online?',
  a: 'Sí. Si ya tenés una tienda, podés usar la formación para ordenar tu marca, mejorar tu contenido, entender tus anuncios, leer métricas y optimizar tu estructura de ventas.'
}, {
  q: '¿Necesito invertir mucho dinero?',
  a: 'No necesitás empezar con una estructura enorme. La idea es que avances de forma estratégica, entendiendo qué herramientas usar, dónde poner el foco y cómo tomar mejores decisiones con tu tienda y tus campañas.'
}, {
  q: '¿En cuánto tiempo voy a ver resultados?',
  a: 'Los resultados dependen de tu constancia, implementación, inversión y del trabajo que hagas sobre tu tienda, contenido y campañas. La formación te da el camino y el acompañamiento para avanzar con más claridad.'
}, {
  q: '¿Cómo es el acompañamiento?',
  a: 'Depende del plan que elijas. Hay opciones con distintos niveles de guía, revisión y seguimiento para que puedas elegir el acompañamiento que mejor se adapte a tu momento.'
}, {
  q: '¿Cuánto tiempo tengo acceso al contenido?',
  a: 'Tenés acceso al contenido durante 6 meses para que puedas avanzar a tu ritmo y repasar cada paso las veces que necesites.'
}, {
  q: '¿Se puede hacer desde cualquier parte del mundo?',
  a: 'Sí. Podés avanzar desde cualquier lugar, siempre que tengas conexión a internet y compromiso para implementar.'
}, {
  q: '¿Tengo que mostrar mi cara o grabar videos?',
  a: 'No necesariamente. Dentro de la formación vas a ver distintas formas de crear contenido y anuncios, incluyendo recursos con inteligencia artificial y edición simple.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-24 px-6 bg-brand-darker relative border-t border-brand-border" data-id="element-2">
      <div className="max-w-3xl mx-auto" data-id="element-3">
        <div className="text-center mb-16" data-id="element-4">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl md:text-5xl font-bold mb-6" data-id="element-5">
            Preguntas Frecuentes
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-lg text-brand-muted" data-id="element-6">
            Resolvé tus dudas antes de empezar.
          </motion.p>
        </div>

        <div className="space-y-4" data-id="element-7">
          {faqs.map((faq, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.05
        }} className="border border-brand-border rounded-2xl bg-brand-card overflow-hidden" data-id="element-8">
              <button onClick={() => setOpenIndex(openIndex === i ? null : i)} className="w-full px-6 py-5 flex items-center justify-between text-left focus:outline-none" data-id="element-9">
                <span className="font-medium text-lg pr-8" data-id="element-10">{faq.q}</span>
                <ChevronDown className={`w-5 h-5 text-brand-gold transition-transform duration-300 shrink-0 ${openIndex === i ? 'rotate-180' : ''}`} data-id="element-11" />
              </button>
              <AnimatePresence data-id="element-12">
                {openIndex === i && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-13">
                    <div className="px-6 pb-5 text-brand-muted" data-id="element-14">{faq.a}</div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}